"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppWrapper = _interopRequireDefault(require("./layout/AppWrapper"));

var _reactRedux = require("react-redux");

var withRoot = function withRoot(Component) {
  var WithRoot =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(WithRoot, _React$Component);

    function WithRoot() {
      (0, _classCallCheck2.default)(this, WithRoot);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithRoot).apply(this, arguments));
    }

    (0, _createClass2.default)(WithRoot, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        //Remove the server-side injected CSS.
        var jssStyles = document.querySelector('#server-side-jss');

        if (jssStyles && jssStyles.parentNode) {
          jssStyles.parentNode.removeChild(jssStyles);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var store = this.props.store; // MuiThemeProvider makes the theme available down the React tree thanks to React context.

        return _react.default.createElement(_reactRedux.Provider, {
          store: store
        }, _react.default.createElement(_AppWrapper.default, this.props, _react.default.createElement(Component, this.props)));
      }
    }]);
    return WithRoot;
  }(_react.default.Component);

  WithRoot.propTypes = process.env.NODE_ENV !== "production" ? {
    muiPageContext: _propTypes.default.object
  } : {};
  return WithRoot;
};

var _default = withRoot;
exports.default = _default;